/**
 * Featured Video (section-home-big-image)
 *
 * The muted autoplay embed can turn YouTube captions on automatically
 * (and the CC button is unreachable because the iframe ignores pointer
 * events), so the caption track is cleared through the IFrame Player API.
 */

const CAPTIONS_OFF_MESSAGE = JSON.stringify({
  event: "command",
  func: "setOption",
  args: ["captions", "track", {}],
});

export function initFeaturedVideo() {
  const iframes = document.querySelectorAll(".featured-video iframe");

  iframes.forEach((iframe) => {
    const disableCaptions = () => {
      iframe.contentWindow.postMessage(CAPTIONS_OFF_MESSAGE, "*");
    };

    iframe.addEventListener("load", disableCaptions);

    // Commands sent before the player is ready are dropped, and captions
    // can reappear when the video loops, so keep clearing the track.
    setInterval(disableCaptions, 5000);
  });
}
